export enum enumMobilMoneyType {
    orangeMoney = 'Orange money',
    mtnMomo = 'MTN momo',
    moovMoney = 'Moov money',
    wave = 'Wave'
}